export interface IRebateDocumentEmail {
  id?: any;
  bankId?: any;
  email?: string | ' ';
  commodityType?: string;
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
}

export const defaultValue: Readonly<IRebateDocumentEmail> = {
  id: '',
  bankId: '',
  email: '',
  commodityType: '',
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
};
